import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Clock } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

/**
 * Case Archive Coming Soon Page
 * 
 * Displayed when V2_ENABLE_CASE_ARCHIVE=false
 * Includes noindex meta tag to prevent search indexing.
 */
export default function CaseArchiveComingSoon() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Case Archive - Coming Soon | Canadian Document Services</title>
      </Helmet>
      
      <div data-testid="case-archive-coming-soon" className="min-h-[60vh] flex items-center justify-center">
        <div className="max-w-xl mx-auto px-4 text-center">
          <div className="w-16 h-16 bg-[hsl(210,20%,96%)] rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="h-8 w-8 text-[hsl(215,50%,23%)]" />
          </div>
          
          <h1 className="text-2xl md:text-3xl font-bold text-[hsl(215,50%,23%)] mb-4">
            Case Archive Coming Soon
          </h1>
          
          <p className="text-gray-600 mb-8">
            We're preparing a comprehensive archive of anonymized case outcomes. 
            This feature will be available in a future update.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/eligibility">
              <Button className="gov-btn-primary">
                Check Eligibility
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link to="/">
              <Button className="gov-btn-secondary">
                Return Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
